import { Box, Divider } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { mapDispatchToProps, mapStateToProps } from './SelectMFA.container';

import { DEFAULT_MFA_OPTIONS } from '/b2b/authentication/state/amplify/Amplify.constants';
import Error from '/b2b/common/components/atoms/Error';
import Header from '/b2b/common/components/molecules/Header';
import Loader from '/b2b/common/components/Loader';
import Locale from '/b2b/common/components/Locale';
import MFAOptionsList from './components/MFAOptionsList';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// eslint-disable-next-line no-use-before-define
export default connect(mapStateToProps, mapDispatchToProps)(SelectMFA);

export function SelectMFA(props) {
    const { getMfaOptions, selectMFA, savedMFAOptions } = props;
    const isMounted = useRef(false);
    const [mfaOptions, setMFAOptions] = useState([...savedMFAOptions]);
    const [isLoading, setIsLoading] = useState(props.isLoading);
    const [head, setHead] = useState('auth.amplify.mfa.select.title');
    const [error, setError] = useState(null);
    const [subhead, setSubhead] = useState('auth.amplify.mfa.select.description');

    const handleSelectMFA = useCallback(
        mfaType => {
            setIsLoading(true);
            return selectMFA(mfaType)
                .then(() => {
                    isMounted.current && setIsLoading(false);
                })
                .catch(error => {
                    isMounted.current && setIsLoading(false);
                    setError(error.message);
                });
        },
        [selectMFA]
    );

    useEffect(() => {
        isMounted.current = true;
        setIsLoading(true);
        let options = Promise.resolve(mfaOptions);
        if (mfaOptions.length === 0) {
            options = getMfaOptions();
        }
        options
            .then(mfaProps => {
                if (mfaProps?.length === 1) {
                    handleSelectMFA(mfaProps[0]);
                } else if (!mfaProps || mfaProps === DEFAULT_MFA_OPTIONS) {
                    // None are configured
                    setHead('auth.amplify.mfa.configure.title');
                    setSubhead('auth.amplify.mfa.configure.description');
                }
                setMFAOptions(mfaProps ?? DEFAULT_MFA_OPTIONS);
                setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
        return () => (isMounted.current = false);
    }, []);

    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="center"
            justifyContent="center"
            sx={{ mx: 'auto', px: 2, width: '100%', position: 'relative' }}
        >
            <Box
                display="flex"
                flexDirection="column"
                width="100%"
                flexGrow={1}
                gap={0.5}
                alignItems="stretch"
                mt={4}
                mb={1}
                sx={theme =>
                    theme.breakpoints.down('lg')
                        ? { justifyContent: 'center', maxWidth: 700 }
                        : { maxWidth: 700 }
                }
            >
                <Header title={head} subtitle={subhead} />
                <Divider />
                <MFAOptionsList options={mfaOptions} onSelect={handleSelectMFA} />
                <Divider />
                {error && (
                    <Error variant="body2" mt={2}>
                        <Locale path={error} />
                    </Error>
                )}
            </Box>
            <Loader loading={isLoading} />
        </Box>
    );
}

SelectMFA.propTypes = {
    isLoading: PropTypes.bool,
    savedMFAOptions: PropTypes.array,
    getMfaOptions: PropTypes.func,
    selectMFA: PropTypes.func,
};
